
import { useMemo } from 'react';
import { format, addDays } from 'date-fns';
import { DaySchedule, ScheduleData } from './types';

export const useScheduleProcessor = () => {
  const processScheduleData = useMemo(() => (
    rawData: ScheduleData[],
    startDate: Date,
    endDate: Date
  ): Map<string, DaySchedule> => {
    console.log('🔍 STEP 3: Iniciando processamento dos dados...');

    // Processar dados por dia
    const scheduleMap = new Map<string, DaySchedule>();
    
    // Inicializar todos os dias do período
    const currentDate = new Date(startDate);
    while (currentDate <= endDate) {
      const dateStr = format(currentDate, 'yyyy-MM-dd');
      scheduleMap.set(dateStr, {
        date: dateStr,
        dayOfWeek: currentDate.getDay(),
        hasSchedule: false,
        periods: [],
        totalSlots: 0
      });
      currentDate.setDate(currentDate.getDate() + 1);
    }

    console.log('🗓️ [useScheduleProcessor] Mapa inicial criado:', {
      totalDays: scheduleMap.size,
      dateRange: `${format(startDate, 'yyyy-MM-dd')} to ${format(endDate, 'yyyy-MM-dd')}`,
      allDates: Array.from(scheduleMap.keys())
    });

    // Agrupar horários por data
    rawData?.forEach((schedule, index) => {
      const dateStr = schedule.date;
      const existing = scheduleMap.get(dateStr);
      
      console.log(`🔄 [useScheduleProcessor] Processando registro ${index + 1}:`, {
        date: dateStr,
        start_time: schedule.start_time,
        end_time: schedule.end_time,
        existing: existing ? 'found' : 'not found',
        scheduleId: schedule.id
      });
      
      if (existing) {
        existing.hasSchedule = true;
        existing.periods.push({
          startTime: schedule.start_time,
          endTime: schedule.end_time
        });

        // Calcular slots (intervalos de 30min)
        const start = new Date(`2000-01-01T${schedule.start_time}`);
        const end = new Date(`2000-01-01T${schedule.end_time}`);
        const diffMinutes = (end.getTime() - start.getTime()) / (1000 * 60);
        const slots = Math.floor(diffMinutes / 30);
        existing.totalSlots += slots;

        scheduleMap.set(dateStr, existing);
        
        console.log(`✅ [useScheduleProcessor] Registro ${index + 1} processado:`, {
          date: dateStr,
          hasSchedule: existing.hasSchedule,
          periodsCount: existing.periods.length,
          totalSlots: existing.totalSlots,
          newPeriod: existing.periods[existing.periods.length - 1]
        });
      } else {
        console.warn(`⚠️ [useScheduleProcessor] Data ${dateStr} não encontrada no mapa inicial!`);
      }
    });

    console.log('🔍 STEP 3: Dados processados - SUCESSO:', {
      totalDays: scheduleMap.size,
      daysWithSchedule: Array.from(scheduleMap.values()).filter(d => d.hasSchedule).length,
      scheduleMapEntries: Array.from(scheduleMap.entries()),
      daysWithScheduleDetails: Array.from(scheduleMap.entries())
        .filter(([, schedule]) => schedule.hasSchedule)
        .map(([date, schedule]) => ({
          date,
          periods: schedule.periods.length,
          totalSlots: schedule.totalSlots
        }))
    });

    return scheduleMap;
  }, []);

  return { processScheduleData };
};
